import React, {
  useRef,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';

/**
 * Bottone della confirm.
 * Lo stato di primary è definito da una combinazione delle proprietà text, flat e primary di Button.
 * Se il bottone è primary, tenta di ottenere il focus dopo il mount.
 */
const ConfirmButton = ({
  text, onClick, disabled, loading, primary,
}) => {
  const ref = useRef();
  useEffect(() => {
    primary && setTimeout(() => {
      ref.current && ref.current.focus();
    }, 0);
  }, [primary]);

  return (
    <Button
      flat={primary}
      text={!primary}
      onClick={onClick}
      className={primary ? 'confirm__button--primary' : undefined}
      primary
      disabled={disabled}
      loading={loading}
      ref={ref}
    >
      {text}
    </Button>
  );
};

ConfirmButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  primary: PropTypes.bool,
};

ConfirmButton.defaultProps = {
  disabled: false,
  loading: false,
  primary: false,
};

export default ConfirmButton;
